<template>
  <div>
    <b-tooltip
      :label="
        access.paid
          ? $t('accesses.userHadAtLeastOneSuccessfulPaymentWithinThisPeriod')
          : $t('accesses.userDidNotHaveAnySuccessfulPaymentWithinThisPeriod')
      "
      position="is-left"
      :type="access.paid ? 'is-success' : 'is-danger'"
      multilined
    >
      <b-icon
        icon="check"
        v-if="access.paid"
        type="is-success"
        size="is-medium"
      ></b-icon>

      <b-icon
        icon="times-circle"
        v-else-if="access.authorized"
        type="is-danger"
        size="is-medium"
      ></b-icon>

      <b-icon
        icon="minus-circle"
        v-else
        type="is-elegant-black-3"
        size="is-medium"
      ></b-icon>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  props: ["access"]
};
</script>
